// Presentational FAQ list (open by default so the text is in the prerendered
// HTML and visible to crawlers/AI). Pair with faqLd() to emit FAQPage JSON-LD.
export default function FaqBlock({ title, items }) {
  if (!items?.length) return null
  return (
    <section className="pep-section">
      <h2 className="pep-h2">{title}</h2>
      <div className="pep-faq">
        {items.map((f, i) => (
          <details className="faq-item" key={i} open>
            <summary>{f.q}</summary>
            <p>{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  )
}
